import type { ContentWithLink } from '@/types/feed-entrys';

/**
 * Generates an internal navigation path based on the link type.
 * @param item - Content item containing link information.
 * @returns Internal path string (e.g. `/news/123`).
 */
export function getInternalLink(item: ContentWithLink): string {
  const itemType = item.cta_type || item.linkType || item.type;
  if (itemType === 'classified') {
    return '/classifieds';
  }

  const relativeLink = item.cta_link || item.link;
  if (itemType === 'unknown' && relativeLink?.startsWith('/')) {
    return relativeLink;
  }

  let path = '/';
  switch (itemType) {
    case 'news':
      path += 'news';
      break;
    case 'event':
      path += 'events';
      break;
    case 'hint':
      path += 'notes';
      break;
    case 'page':
      path += 'pages';
      break;
    default:
      path += 'start';
  }

  const itemLink = item.cta_link || item.link;
  if (itemLink && itemLink !== '0') {
    path += `/${itemLink}`;
  }

  return path;
}
